import script from "./Recommend.vue?vue&type=script&setup=true&lang=js"
export * from "./Recommend.vue?vue&type=script&setup=true&lang=js"

import "./Recommend.vue?vue&type=style&index=0&id=5a12397d&lang=scss&scoped=true"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a12397d"]])

export default __exports__